package com.macrofocus.eflux.network

import com.macrofocus.common.selection.SimpleSingleSelection
import com.macrofocus.common.selection.SingleSelection
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Bus
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import org.molap.network.AbstractNetwork
import org.molap.network.NetworkListener
import org.molap.network.WeightedNetwork

class QuestDBWeightedNetwork(val branchDataFrame: DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>): AbstractNetwork<Bus, Branch>(),
    WeightedNetwork<Bus, Branch, Any> {

   private val directedSelection = SimpleSingleSelection(false)

    init {
        val from = branchDataFrame.rows().map { it.from }.toSet()
        val to = branchDataFrame.rows().map { it.to }.toSet()
        val merged = from + to
        merged.forEach { addNode(it) }

        for (row in branchDataFrame.rows()) {
            addUndirectedEdge(row.from, row.to, row)
        }
    }

    override fun getDirectedSelection(): SingleSelection<Boolean> {
        return directedSelection
    }

    override fun getDirectedLinks(from: Bus): Iterable<Branch> {
        return getLinks(from)
    }

    override fun getReverse(edge: Branch): Branch {
        return edge
    }

    override fun getWeight(link: Branch): Any {
        return 1.0
//        return link.pratea
//        return link.p.amount
    }

    override fun addNetworkListener(listener: NetworkListener) {
    }

    override fun removeNetworkListener(listener: NetworkListener) {
    }
}